import search from './search';

export default {
  cat4mro: {
    pages: {
      ...search,
    },
  },
};



// WEBPACK FOOTER //
// ./src/i18n/es-cl/buyer/cat4mro/index.js